import React from 'react';

import { Stack, Title, useMantineTheme } from '@mantine/core';
import AthleteAttendanceTableContainer from 'pages/private/owner/AthleteDetail/components/Attendance/components/AthleteAttendanceTableContainer';
import { AthletePackageRetrieve } from 'types';

interface IAttendanceTabProps {
  athletePackage: AthletePackageRetrieve;
  permission?: boolean;
}

const AttendanceTab = ({ athletePackage, permission = true }: IAttendanceTabProps): JSX.Element => {
  const theme = useMantineTheme();
  const attendanceSearchFiltersValue = {
    athlete: athletePackage.athlete,
    athletePackage: athletePackage.athletePackageId,
  };

  return (
    <Stack sx={{ [theme.fn.smallerThan('sm')]: { display: 'block' } }}>
      <Title order={3}>Attendance</Title>
      <AthleteAttendanceTableContainer
        searchFilters={attendanceSearchFiltersValue}
        permission={permission}
        limit='10000000'
      />
    </Stack>
  );
};

export default AttendanceTab;
